import { useStationeryProductsQuery } from './DesignsGallery.graphql.generated';
import type { StationeryProduct } from '@shared/utils/print-price/types';

const ZERO_PRODUCTS: StationeryProduct[] = []; // For stability

/**
 * The product list plus whether it has settled.
 *
 * Callers that only render the list can use `useProducts` and ignore this — an empty array renders
 * as nothing either way. A caller that *acts* on the list needs the flag: an empty array is both
 * "not back yet" and "genuinely none", and treating the second as the first hangs forever.
 */
export const useProductsWithStatus = (): { products: StationeryProduct[]; isLoading: boolean } => {
  const {
    data: productData,
    loading,
    error: productsError,
  } = useStationeryProductsQuery({
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    ssr: false,
  });

  if (productsError) throw productsError;

  return { products: productData?.stationeryProducts ?? ZERO_PRODUCTS, isLoading: loading && !productData };
};

export const useProducts = (): StationeryProduct[] => useProductsWithStatus().products;
